export const videoGuidStyle = {
  watchVideoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  videoIconTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
  },
  videoNeedHelp: {
    fontFamily: '"Manulife JH Sans"',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    marginRight: '10px',
  },
  videoIcon: {
    width: '24px',
    height: '24px',
    marginRight: '10px',
  },
  videoWatchText1: {
    fontFamily: 'Manulife JH Sans',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20px',
    marginRight: '10px',
  },

  videoWatchText2: {
    fontFamily: 'Manulife JH Sans',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    marginLeft: '8px',
    color: '#282B3E',
  },

  cross: {
    width: '24px',
    height: '24px',
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    cursor: 'pointer',
    background: 'none',
    borderStyle: 'none',
    padding: '1rem',
    color: '#fff',
  },
};
